import { ActionButtonVariants } from 'components/action-button';

export const BUTTON_VARIANT = ActionButtonVariants.PRIMARY;
